/**
 *  Supported types of input.
 */
enum InputType {
    Checkbox = 'checkbox',
    Date = 'date',
    Email = 'email',
    Number = 'number',
    Radio = 'radio',
    Select = 'select',
    Text = 'text',
    Textarea = 'textarea',
}

export default InputType;
